import { render, staticRenderFns } from "./RecommendDoctorList.vue?vue&type=template&id=496391f2&scoped=true&"
import script from "./RecommendDoctorList.vue?vue&type=script&lang=js&"
export * from "./RecommendDoctorList.vue?vue&type=script&lang=js&"
import style0 from "./RecommendDoctorList.vue?vue&type=style&index=0&id=496391f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496391f2",
  null
  
)

export default component.exports